import React from 'react';
import { LayoutProps, SpaceProps } from 'styled-system';

import { useSidebar } from '@constants/globals';
import { isEmptyChild } from 'utils/react';

import { Container, Content, LinkSidebarItem, Span } from './styles';

type PropTypes = {
  title?: React.ReactNode;
  children?: React.ReactNode;
  to?: string;
  className?: string;
  leftSpace?: boolean;
  onClick?: (event: React.MouseEvent | undefined) => void;
  highlight?: boolean;
} & SpaceProps &
  LayoutProps;

const SidebarSectionItem = ({
  title = null,
  children = null,
  to,
  leftSpace = true,
  className,
  onClick,
  highlight = true,
  ...props
}: PropTypes): JSX.Element => {
  const [, setIsSidebarOpen] = useSidebar();

  return (
    <Container className={className} {...props}>
      {to ? (
        <LinkSidebarItem
          dataTestId="sidebar-section-item"
          href={to}
          forceActive={highlight}
          onClick={(event): void => {
            setIsSidebarOpen(false);
            if (onClick) onClick(event);
          }}
        >
          {title}
        </LinkSidebarItem>
      ) : (
        <Span
          onClick={(event): void => {
            setIsSidebarOpen(false);
            if (onClick) onClick(event);
          }}
        >
          {title}
        </Span>
      )}
      {!isEmptyChild(children) && <Content leftSpace={leftSpace}>{children}</Content>}
    </Container>
  );
};

export default SidebarSectionItem;
